/* Follie by Alice – correzioni dall'audit UX del 24/09/2026 (aggiornato il 30/09/2026).
   Solo per i punti in cui Ella 7.2 non offre un'impostazione nativa nell'editor. */
(function () {
  'use strict';

  /* 1. Pallini colore sulle card prodotto.
        Ella 7 legge data-title/data-variant-id dall'elemento toccato: se il tocco cade sul bordo
        del pallino (li.swatch-item) o sul tooltip, quell'elemento non ha i dati, il colore non cambia
        e in console compare "undefined is not an object (evaluating 'title.replace')".
        Reindirizziamo il tocco sul pallino vero.
        30/10/2026: esclusi i pallini che contengono un input (radio del popup "Scegli opzioni" di
        "Acquista il look"): li gestisce il browser tramite la label, e bloccare il clic sull'input
        impediva di cambiare colore. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.hasAttribute && target.hasAttribute('data-title')) return;
    var item = target.closest('.card-wrapper .swatch-item');
    if (!item) return;
    if (item.querySelector('input')) return;
    var swatch = item.querySelector('[data-title]');
    if (!swatch || swatch === target) return;
    event.preventDefault();
    event.stopPropagation();
    swatch.click();
  }, true);

  /* 2. Nome accessibile ai pulsanti-icona che non ne hanno uno (tema e app BLOY). */
  var LABELS = [
    ['.bundle-option-close', 'Chiudi'],
    ['.button--drawer', 'Apri la barra laterale del blog'],
    ['.BLOY-popup__action--close', 'Chiudi']
  ];

  function addLabels() {
    LABELS.forEach(function (pair) {
      var nodes = document.querySelectorAll(pair[0]);
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (!el.getAttribute('aria-label') && !(el.textContent || '').trim()) {
          el.setAttribute('aria-label', pair[1]);
        }
      }
    });
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; addLabels(); }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addLabels);
  } else {
    addLabels();
  }
  if ('MutationObserver' in window) {
    new MutationObserver(schedule).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  /* 3. TEST (solo tema TEST v11) – mini-anteprima del colore scelto accanto a "Colore: …".
        Su mobile la galleria cambia foto fuori dallo schermo: la miniatura 56×75 mostra il colore
        appena toccato senza risalire. Toccandola si torna alla galleria.
        Per spegnerla: COLOR_THUMB = false. */
  var COLOR_THUMB = true;

  function initColorThumb() {
    if (!COLOR_THUMB || !/\/products\//.test(location.pathname)) return;
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var details = document.querySelector('.product-details');
    if (!details) return;
    var url = location.pathname.replace(/\/$/, '') + '.js';
    fetch(url).then(function (r) { return r.json(); }).then(function (product) {
      var colorIdx = -1;
      var colorName = '';
      (product.options || []).forEach(function (o, i) {
        var name = (o.name || o).toString();
        if (/^(colore|color|colour)$/i.test(name)) { colorIdx = i; colorName = name; }
      });
      if (colorIdx < 0) return;
      var imgByColor = {};
      product.variants.forEach(function (v) {
        var val = v.options[colorIdx];
        if (!imgByColor[val] && v.featured_image) imgByColor[val] = v.featured_image.src;
      });
      function update() {
        var fieldset = null;
        var sets = details.querySelectorAll('variant-selects fieldset');
        for (var i = 0; i < sets.length; i++) {
          var lg = sets[i].querySelector('legend');
          if (lg && lg.textContent.trim().indexOf(colorName + ':') === 0) { fieldset = sets[i]; break; }
        }
        if (!fieldset) return;
        var legend = fieldset.querySelector('legend');
        var valueEl = legend && legend.querySelector('[data-selected-value]');
        var value = valueEl ? valueEl.textContent.trim() : '';
        var src = imgByColor[value];
        var thumb = fieldset.querySelector('.follie-color-thumb');
        if (!src) { if (thumb) thumb.remove(); return; }
        if (!thumb) {
          thumb = document.createElement('button');
          thumb.type = 'button';
          thumb.className = 'follie-color-thumb';
          thumb.innerHTML = '<img alt="" width="56" height="75">';
          thumb.addEventListener('click', function () {
            var gallery = document.querySelector('.product-information media-gallery, .product-information [class*="media-gallery"], .product-information__media');
            (gallery || document.body).scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
          legend.appendChild(thumb);
        }
        thumb.setAttribute('aria-label', 'Colore ' + value + ': torna alle foto');
        var img = thumb.querySelector('img');
        var sized = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        if (img.getAttribute('src') !== sized) img.setAttribute('src', sized);
      }
      update();
      if ('MutationObserver' in window) {
        var pending = false;
        new MutationObserver(function () {
          if (pending) return;
          pending = true;
          setTimeout(function () { pending = false; update(); }, 150);
        }).observe(details, { childList: true, subtree: true, characterData: true });
      }
    }).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColorThumb);
  } else {
    initColorThumb();
  }

  /* 4. Collezioni: "Carica altro" vero (audit 30/09/2026, UX-024).
        Ella offre solo la paginazione a numeri o uno scroll infinito che carica da solo e riscrive l'URL:
        qui i prodotti successivi arrivano SOLO al tocco del pulsante, l'URL non cambia e, tornando
        indietro da una scheda, vengono ricaricate le pagine già viste e ripristinata la posizione.
        La paginazione a numeri resta nell'HTML (link leggibili dai motori di ricerca) ma è nascosta.
        Si attiva solo sulle collezioni aperte da pagina 1. Per spegnerlo: LOAD_MORE = false. */
  var LOAD_MORE = true;
  var LM_KEY = 'follieLM:';
  var LM_MAX_AGE = 30 * 60 * 1000;

  function lmStateKey() { return LM_KEY + location.pathname + location.search; }
  function lmRead() {
    try {
      var s = JSON.parse(sessionStorage.getItem(lmStateKey()) || 'null');
      if (s && Date.now() - s.t < LM_MAX_AGE) return s;
    } catch (e) {}
    return null;
  }
  function lmWrite(pages) {
    try {
      sessionStorage.setItem(lmStateKey(), JSON.stringify({ pages: pages, y: Math.round(window.scrollY), t: Date.now() }));
    } catch (e) {}
  }
  function lmNavType() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (nav) return nav.type;
    } catch (e) {}
    return 'navigate';
  }

  function initLoadMore() {
    if (!LOAD_MORE || !/^\/collections\/[^/]+\/?$/.test(location.pathname)) return;

    function enhance() {
      var grid = document.querySelector('#ResultsList ul.product-grid, ul.product-grid#product-grid');
      if (!grid || grid.getAttribute('data-follie-lm')) return;
      var wrapper = grid.closest('.collection') && grid.closest('.collection').querySelector('.pagination-wrapper');
      var nav = wrapper && wrapper.querySelector('nav.pagination');
      var current = parseInt(grid.dataset.currentPage, 10) || 1;
      var totalPages = parseInt(grid.dataset.totalPages, 10) || 1;
      var totalItems = parseInt(grid.dataset.totalItems, 10) || 0;
      if (!wrapper || !nav || current !== 1 || totalPages < 2) return;
      grid.setAttribute('data-follie-lm', '1');

      var sectionId = grid.dataset.id || '';
      var page = 1;
      var busy = false;

      var box = document.createElement('div');
      box.className = 'follie-lm';
      box.innerHTML =
        '<p class="follie-lm__count"></p>' +
        '<div class="follie-lm__bar" aria-hidden="true"><span></span></div>' +
        '<button type="button" class="button button--primary follie-lm__button" aria-controls="' + (grid.id || 'product-grid') + '">Mostra altri prodotti</button>' +
        '<p class="visually-hidden follie-lm__status" role="status" aria-live="polite"></p>';
      nav.classList.add('follie-lm__nav');
      wrapper.appendChild(box);
      var countEl = box.querySelector('.follie-lm__count');
      var barEl = box.querySelector('.follie-lm__bar span');
      var btn = box.querySelector('.follie-lm__button');
      var statusEl = box.querySelector('.follie-lm__status');

      function shown() { return grid.querySelectorAll('.product-grid__item').length; }
      function render() {
        var n = shown();
        var tot = totalItems || n;
        countEl.textContent = 'Hai visto ' + n + ' di ' + tot + ' prodotti';
        barEl.style.width = Math.min(100, Math.round(n * 100 / tot)) + '%';
        if (page >= totalPages) {
          btn.hidden = true;
          countEl.textContent = 'Hai visto tutti i ' + tot + ' prodotti';
        }
      }

      function pageUrl(p) {
        var u = new URL(location.href);
        u.searchParams.set('page', p);
        if (sectionId) u.searchParams.set('section_id', sectionId);
        return u.toString();
      }

      function fetchPage(p) {
        return fetch(pageUrl(p), { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var items = doc.querySelectorAll('.product-grid__item');
            if (!items.length) throw new Error('vuota');
            var frag = document.createDocumentFragment();
            items.forEach(function (it) {
              var node = document.importNode(it, true);
              node.dataset.page = p;
              frag.appendChild(node);
            });
            grid.appendChild(frag);
            page = p;
            return items.length;
          });
      }

      function afterAppend() {
        try { if (window.lazyLoad && window.lazyLoad.update) window.lazyLoad.update(); } catch (e) {}
        try { if (typeof window.initMoreSwatchButtons === 'function') window.initMoreSwatchButtons(grid); } catch (e) {}
        try {
          if (window.QuickAdd && window.QuickAdd.initButton) {
            grid.querySelectorAll('[data-page="' + page + '"] [data-quick-add]').forEach(function (b) { window.QuickAdd.initButton(b); });
          }
        } catch (e) {}
        try {
          document.dispatchEvent(new CustomEvent('productsLoaded', { detail: { page: page, totalPages: totalPages, hasNextPage: page < totalPages } }));
        } catch (e) {}
        render();
      }

      function fail() {
        /* Se il caricamento non riesce, si torna alla paginazione a numeri. */
        nav.classList.remove('follie-lm__nav');
        box.remove();
      }

      btn.addEventListener('click', function () {
        if (busy || page >= totalPages) return;
        busy = true;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = 'Caricamento…';
        var before = shown();
        fetchPage(page + 1).then(function (added) {
          afterAppend();
          lmWrite(page);
          statusEl.textContent = 'Caricati altri ' + added + ' prodotti. ' + countEl.textContent + '.';
          var first = grid.querySelectorAll('.product-grid__item')[before];
          var link = first && first.querySelector('a[href]');
          if (link && document.activeElement === btn && btn.hidden) link.focus({ preventScroll: true });
        }).catch(fail).then(function () {
          busy = false;
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.textContent = 'Mostra altri prodotti';
        });
      });

      /* Memorizza pagine caricate e posizione quando si apre una scheda o si lascia la pagina. */
      grid.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('a[href]')) lmWrite(page);
      }, true);
      window.addEventListener('pagehide', function () { if (grid.isConnected) lmWrite(page); });

      render();

      /* Ritorno da una scheda (indietro) o ricarica: ripristina pagine e posizione. */
      var type = lmNavType();
      var saved = lmRead();
      if (saved && (type === 'back_forward' || type === 'reload') && saved.pages > 1) {
        var target = Math.min(saved.pages, totalPages);
        var chain = Promise.resolve();
        for (var p = 2; p <= target; p++) {
          (function (pp) { chain = chain.then(function () { return fetchPage(pp); }); })(p);
        }
        chain.then(function () {
          afterAppend();
          window.scrollTo(0, saved.y);
          setTimeout(function () { window.scrollTo(0, saved.y); }, 300);
        }).catch(function () { afterAppend(); });
      }
    }

    /* Se al ritorno ci sono pagine da ricaricare, la posizione la gestiamo noi. */
    var pre = lmRead();
    if (pre && pre.pages > 1 && lmNavType() !== 'navigate' && 'scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    enhance();
    /* I filtri di Ella sostituiscono la griglia: il pulsante va ricreato. */
    if ('MutationObserver' in window) {
      var root = document.getElementById('ProductGridContainer') ? document.getElementById('ProductGridContainer').parentElement : document.body;
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(enhance, 200);
      }).observe(root, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLoadMore);
  } else {
    initLoadMore();
  }
})();


/* 5. Campi di ricerca senza etichetta (UX-039, audit UX 21/10/2026).
      Il campo della pagina /search (#Search-In-Template) ha solo il placeholder "Cerca": i lettori di schermo
      non lo annunciano. Ella non offre un'etichetta per quel campo nell'editor né in "Modifica contenuti tema".
      Aggiungiamo aria-label (dal placeholder) solo ai campi di ricerca che non hanno né label né aria-label. */
(function () {
  'use strict';
  function labelSearch() {
    document.querySelectorAll('input[type="search"]').forEach(function (i) {
      if (i.getAttribute('aria-label') || i.getAttribute('aria-labelledby')) return;
      if (i.labels && i.labels.length) return;
      i.setAttribute('aria-label', i.getAttribute('placeholder') || 'Cerca');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', labelSearch);
  } else {
    labelSearch();
  }
})();
